import { KNOWLEDGE_BASE } from "src/pages/context-hub/components/use-knowledge-section";

export const SKILLS_LIST_PATH = `${KNOWLEDGE_BASE}/skills`;

/** The builder for a new skill, created on its first save. */
export const NEW_DAG_SKILL_PATH = `${SKILLS_LIST_PATH}/new/builder`;

/** The builder for a skill written as steps. */
export function dagSkillPath(id: string): string {
  return `${SKILLS_LIST_PATH}/${id}/builder`;
}
